<template>
    <div class="search-fields">
        <popular-search-destination
            :value="selectedDestinationAirport"
            @input="selectDestinationAirport"
            :validation="validation"
            :show-selector="showSelector"
            :open-modal="openModal"
            :show-custom-destinations="true"
            :departureAirport="form.departureAirport"
            @hide="showSelector = null"
            @show="showSelector = 'destination-selector'"
        >
        </popular-search-destination>
        <div class="search-field search-dates">
            <input-field ref="fromDate" :name="translations.travel_dates" :readonly="true" icon-type="calendar" @click="showSelector = 'calendar'; dateSelection = 'FROM_DATE'" :value="dateString" :error="validation.fromDate || validation.toDate"></input-field>
            <skov-range-picker ref="calendar" v-if="showSelector == 'calendar'" @close="closeCalendar" :value="initRange" @input="selectDates" :use-noscroll="useNoscroll" :showDateInputs="false"></skov-range-picker>
        </div>
        <div class="search-field search-field--travelers">
            <input-field :name="translations.number_of_travelers" :value="numberOfTravelers" :readonly="true" icon-type="travelers" @focus="showSelector = 'travelers'" :error="validation.adults || validation.children"></input-field>
            <modal class="modal--search-widget" :title="translations.number_of_travelers" v-if="showSelector == 'travelers'" @close="showSelector = null" :close-on-click="true" :is-open="openModal == 'travelers'">
                <img src="../../../../../assets/img/icons/icon-persons.svg" alt="" slot="icon">
                <ul class="modal-view-list modal-view-list--no-hover">
                    <li class="modal-view-list__item">
                        <span class="modal-view-list__item__text" v-text="translations.number_of_adults"></span>
                        <count-picker :max="4" :min="0" v-model="form.adults"></count-picker>
                    </li>
                    <li class="modal-view-list__item">
                        <span class="modal-view-list__item__text" v-text="translations.number_of_children"></span>
                        <count-picker :min="0" :max="4" v-model="form.childrenCount"></count-picker>
                    </li>
                    <li class="modal-view-list__item" v-for="(val, key) in form.children" :key="key">
                        <span class="modal-view-list__item__text" v-text="translations.children_ages.replace(/{n}/, key + 1)"></span>
                        <count-picker v-model="form.children[key]" :min="-1" :placeholder="translations.age" :max="maxChildrenAge"></count-picker>
                    </li>
                    <li class="modal-view-list__item"><a href="/vigtig-information/grupperejsebestilling" class="modal-view-list__item__link" v-text="translations.grouptravel"></a></li>
                </ul>
                <div slot="footer" class="modal-view__footer">
                    <button v-text="translations.ok_btn" class="btn btn--success" :disabled="validForm && (validForm.children || validForm.adults)" @click="showSelector = null"></button>
                </div>
            </modal>
        </div>
        <button class="btn btn-with-icon btn--positive search-fields__btn" @click="search" :disabled="validForm">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.95 19.95"><path d="m19.55,17.53l-3.77-3.77c.93-1.42,1.37-3.19,1.37-5.18,0-2.55-.72-4.74-2.28-6.3-1.56-1.55-3.75-2.28-6.3-2.28S3.83.72,2.28,2.28C.72,3.83,0,6.02,0,8.58s.72,4.74,2.28,6.3c1.56,1.55,3.75,2.28,6.3,2.28,1.99,0,3.76-.44,5.18-1.37l3.77,3.77c.27.26.63.4,1,.4.37,0,.73-.15,1-.42.26-.26.42-.62.42-1,0-.37-.14-.74-.4-1Zm-6.69-4.67c-.88.87-2.25,1.44-4.28,1.44s-3.4-.56-4.28-1.44-1.44-2.25-1.44-4.28.56-3.4,1.44-4.28c.87-.88,2.25-1.44,4.28-1.44s3.4.56,4.28,1.44c.87.87,1.44,2.25,1.44,4.28s-.56,3.4-1.44,4.28Z" style="fill:#fff; fill-rule:evenodd;"/></svg>
            <span v-text="translations.search"></span>
        </button>
        <modal class="modal-view--bg modal-view--group-travel" title="Grupperejsebestilling" v-if="showSelector == 'group-travel'" @close="showSelector = null" :is-open="openModal == 'group-travel'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.18 490.04" class="icon-person" slot="icon"><path d="M187.83,490c-44.06-.32-79.51-1.42-114.53-8.06-16.73-3.17-33.16-7.4-48.23-15.71C8.75,457.27.19,444.48,0,424.83c-.21-21.56,11.12-35.61,25.83-48.29,20.79-17.91,45-30.12,69.93-41.1,4.57-2,9.12-4.19,13.9-5.53,8.62-2.41,13.8-8.24,17.51-15.87A42.14,42.14,0,0,0,129,280.57c-.73-2.09-2.42-3.93-3.91-5.67C96.59,241.43,81,203,81.59,158.77c.32-25.36,7.35-48.77,24.82-67.92,21.2-23.23,48.34-31.89,79-29.4,32.18,2.61,57.94,17.15,74.54,45.41,13.34,22.71,16.26,47.73,12.73,73.46-5,36.2-20.7,67.49-44.65,94.86a18.74,18.74,0,0,0-3.85,7.33c-3.6,13.69-3.61,27.16,4.83,39.29a18.61,18.61,0,0,0,8.39,6.44c29.36,10.71,57.72,23.31,83,42.07,10.08,7.49,19.13,16,26,26.7,14.23,22.06,7.59,53.21-14.48,67.19-15.63,9.9-33.2,14.53-51.12,17.66-14.41,2.52-29,4.54-43.56,5.7C217.94,489.08,198.61,489.53,187.83,490Z" transform="translate(0 0)"/><path d="M264.52,296c9.67-16.23,20.19-31.52,28.32-48,19.06-38.58,25.93-79.26,16.62-121.85-6-27.29-19.11-50.62-39.86-69.5-1.23-1.12-2.43-2.27-3.65-3.41a7.06,7.06,0,0,1-.51-.85c8-20.13,21.34-35.95,41.78-44.21,34.6-14,67.46-10.75,96.16,14.36,17.8,15.57,25.73,36.72,27.52,59.82,3.48,44.91-9.28,84.89-38.46,119.42-5.29,6.25-7.79,22.53-3.24,29.32a23,23,0,0,0,10.74,8.07c20.68,7.58,41,16,59.94,27.19,16.27,9.63,31.76,20.26,42.74,36.18,16.08,23.29,8.83,53.81-16.07,67.22-18.8,10.13-39.36,14.23-60.21,17.05-11.71,1.59-23.52,2.46-35.31,3.34-1.61.12-4.27-1.19-4.9-2.55-9.89-21.59-26.14-37.58-44.89-51.35-21.35-15.67-44.9-27.31-69.35-37.23C269.12,298,266.37,296.8,264.52,296Z" transform="translate(0 0)"/></svg>
            <group-travel></group-travel>
        </modal>
    </div>
</template>

<script>
import InputField from './../../input-field.vue';
import Moment from 'moment';
import SkovRangePicker from './../../daterangepicker/skovrangepicker.vue';
import Modal from './../../modal.vue';
import Validate from 'validate.js';
import QueryString from 'query-string';
import CountPicker from './../../count-picker.vue';
import GroupTravel from './../../group-travels.vue';
import _ from 'underscore';

import PopularSearchDestination from './popular-search-destination.vue';
import { trackEvent } from "./../../../tracker";

export default {
    props: {
        setDestinationAirport: {type: String, default: null},
        setDepartureAirport: {type: String, default: null},
        useNoscroll: {type: Boolean, default: true}
    },
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.FRONTPAGE_SEARCH_WIDGET,
            maxChildrenAge: APP_CONFIG.MAX_AGE_CHILDREN,
            showSelector: null,
            openModal: null,
            selectedDestinationAirport: null,
            validation: { },
            dateSelection: null,
            destinationChange: false,
            form: {
                fromDate: Moment().set({hour: 0, minute: 0, second: 0}).add(1, 'month'),
                toDate: Moment().set({hour: 0, minute: 0, second: 0}).add(1, 'month').add(7, 'days'),
                departureAirport: 'HAM',
                destinationId: null,
                adults: 2,
                childrenCount: 0,
                children: [ ],
                flexibleStartDays: 0,
                flexibleEndDays: 0
            }
        }
    },
    mounted() {
        this.setForm();
        if(this.setDestinationAirport) {
            this.selectDestinationAirport(JSON.parse(this.setDestinationAirport));
        }

        if(this.setDepartureAirport) {
            this.selectDepartureAirport({value: this.setDepartureAirport});
        }

        if(this.$route.query.grouptravelmodel) {
            this.showSelector = 'group-travel';
        }
    },
    watch: {
        showSelector(newSelector, oldSelector) {
            setTimeout(() => {
                this.openModal = this.showSelector;
            }, 250);
        },
        'destination'() {
            this.setForm();
        },
        'travelQuery'() {
            this.setForm();
        },
        'form.childrenCount'(newVal, oldVal) {
            let children = Object.assign([ ], this.form.children);
            let newChildrenList = [ ];

            for(let i = 0; i<newVal; i++) {
                newChildrenList.push((children[i]) ? children[i] : -1);
            }

            this.form.children = newChildrenList;
        },
        'form.destinationId'(newDestinationId) {
            if(this.travelQuery) {
                let destinationId = this.travelQuery.destinationId;
                this.destinationChange = (destinationId != newDestinationId) ? true : false;
            }
        },
        'form.flexibleStartDays'() {
            if(this.showSelector == 'calendar') {
                trackEvent({
                    event: 'Valg af fleksibilitet - Fra',
                    action: this.form.flexibleStartDays,
                    'interaction-type': 'noninteraction',
                });
            }
        },
        'form.flexibleEndDays'() {
            if(this.showSelector == 'calendar') {
                trackEvent({
                    event: 'Valg af fleksibilitet - Til',
                    action: this.form.flexibleEndDays,
                    'interaction-type': 'noninteraction',
                });
            }
        },
        'setDepartureAirport'() {
            if(this.setDepartureAirport) {
                this.selectDepartureAirport({value: this.setDepartureAirport});
            }
        }
    },
    methods: {
        onGroupTravelClick() {
            this.showSelector = 'group-travel';
            trackEvent({
                event: 'CTA Klik - Flere værelser',
                'interaction-type': 'noninteraction',
            })
        },
        openCalendar() {
            this.showSelector = 'calendar';
        },
        closeCalendar(evt) {
            if(!evt) {
                this.showSelector = null;
            } else if(!this.$refs.fromDate.$el.contains(evt.target)) {
                this.showSelector = null;
            }
        },
        selectDates(dateObj, evt) {
            this.form.fromDate = (dateObj.start) ? dateObj.start : null;
            this.form.toDate = (dateObj.end) ? dateObj.end : null;
            this.form.flexibleStartDays = dateObj.flexibleStartDays || 0;
            this.form.flexibleEndDays = dateObj.flexibleEndDays || 0;
        },
        setForm() {
            if(this.travelQuery && this.travelQuery.destinationId) {
                this.selectedDestinationAirport = this.destination;
                this.form = Object.assign({}, this.travelQuery);
            }
        },
        search() {
            this.validation = { };
            let errors = this.validForm;
            if(errors) {
                this.validation = Object.assign({}, errors);
                return;
            }

            if(this.selectedDestinationAirport.type === 'special') {
                switch(this.selectedDestinationAirport.id) {
                    case 'showalldestinations':
                        let query = {
                            fromDate: this.form.fromDate.format('YYYY-MM-DD'),
                            toDate: this.form.toDate.format('YYYY-MM-DD'),
                            adults: this.form.adults,
                            children: JSON.stringify(this.form.children),
                            flexibleStartDays: this.form.flexibleStartDays,
                            flexibleEndDays: this.form.flexibleEndDays
                        };

                        if(APP_CONFIG.UTM_SOURCE) { //On external open price overview in new window
                            window.open(APP_CONFIG.APP_URL + '/prisoversigt?' + APP_CONFIG.UTM_SOURCE + '&' + QueryString.stringify(query));
                        } else {
                            window.location = APP_CONFIG.APP_URL + '/prisoversigt?' + QueryString.stringify(query);
                        }
                        return;
                }
            } else {
                let query = Object.assign({}, this.form);
                if(this.destinationChange) {
                    query = _.pick(query, ['fromDate', 'toDate', 'departureAirport', 'destinationId', 'adults', 'childrenCount', 'children', 'flexibleStartDays', 'flexibleEndDays']);
                } else if(this.form.keywords) {
                    query.keywords = JSON.stringify(this.form.keywords);
                }

                query = Object.assign({}, query, {
                            fromDate: this.form.fromDate.format('YYYY-MM-DD'),
                            toDate: this.form.toDate.format('YYYY-MM-DD'),
                            children: JSON.stringify(this.form.children),
                            minPrice: null,
                            maxPrice: null
                        });

                this.destinationChange = false;                
                if(this.isFrontpage) {
                    this.$emit('search');
                    this.$router.push({
                        path:'/hotels',
                        query
                    });
                } else {
                    let location = '/#/hotels?' + QueryString.stringify(query);
                    if(APP_CONFIG.UTM_SOURCE) { //On external open search results in new window
                        location = APP_CONFIG.APP_URL + '?' + APP_CONFIG.UTM_SOURCE + location;
                        window.open(location);
                        return;
                    }

                    window.location = APP_CONFIG.APP_URL + location;
                }
            }
        },
        selectDepartureAirport(airport) {
            this.$set(this.form, 'departureAirport', airport.value);
            this.showSelector = null;
        },
        selectDestinationAirport(airport) {
            this.selectedDestinationAirport = airport;
            this.$set(this.form, 'destinationId', airport.id);
            this.showSelector = null;
            trackEvent({
                event: 'CTA Klik - Valg af destination',
                destination: airport,
                'interaction-type': 'noninteraction',
            });
        },
    },
    computed: {
        dateString() {
            let dateStr = '';
            
            if(this.form.fromDate) {
                dateStr += this.form.fromDate.format('DD. MMM');
                if(this.form.flexibleStartDays > 0) {
                    dateStr += ` (- ${this.form.flexibleStartDays})`;
                }
            }
            
            if(this.form.toDate) {
                dateStr += ` -  ${this.form.toDate.format('DD. MMM')}`;
                if(this.form.flexibleEndDays > 0) {
                    dateStr += ` (+ ${this.form.flexibleEndDays})`;
                }
            }

            return dateStr;
        },
        destination() {
            return (this.$store) ? this.$store.state.destination : null;
        },
        travelQuery() {
            return (this.$store) ? this.$store.getters.travelQuery : null;
        },
        validForm() {
            let errors = Validate(this.form, {
                fromDate: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.from_date  
                    }
                },
                toDate: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.to_date
                    }
                },
                departureAirport: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.departure_airport                    
                    }
                },
                destinationId: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.destination_id                        
                    }
                },
                adults: {
                    numericality: {
                        message: this.translations.ERRORS.adults
                    }
                },
                childrenCount: {
                    numericality: {
                        message: this.translations.ERRORS.children                    
                    }
                },
                flexibleStartDays: {
                    numericality: {
                        message: this.translations.ERRORS.flexible_days
                    }
                },
                flexibleEndDays: {
                    numericality: {
                        message: this.translations.ERRORS.flexible_days
                    }
                }
            }, {
                fullMessages: false
            });

            if(this.form.adults === 0 && this.form.childrenCount === 0) {
                if(!errors) {
                    errors = { };
                }

                errors['adults'] = this.translations.ERRORS.adults;
                errors['children'] = this.translations.ERRORS.children;
            }

            if(this.form.children && Array.isArray(this.form.children) && this.form.children.filter((age) => age == -1).length) {
                if(!errors) {
                    errors = { };
                }

                errors['children'] = this.translations.ERRORS.children;
            }

            return (errors) ? errors : null;
        },
        numberOfTravelers() {
            let str = this.form.adults.toString() + ' ';
            str += (this.form.adults > 1 || this.form.adults === 0) ? this.translations.adults : this.translations.adult_single;
            str += ', ' + this.form.childrenCount + ' ';
            str += (this.form.childrenCount > 1 || this.form.childrenCount === 0) ? this.translations.children : this.translations.children_single;
            return str;
        },
        initRange() {
            return {
                start: Moment(this.form.fromDate).toDate(),
                end: Moment(this.form.toDate).toDate(),
                flexibleStartDays: this.form.flexibleStartDays,
                flexibleEndDays: this.form.flexibleEndDays
            }
        },
        isFrontpage() {
            return (this.$route && (this.$route.name === 'Frontpage' || this.$route.name === 'Hotels'));
        }
    },
    components: {
        'input-field': InputField,
        'modal': Modal,
        CountPicker,
        GroupTravel,
        PopularSearchDestination,
        SkovRangePicker
    }
}
</script>

